/**
 * Drain every row matching a filter, in keyset batches — the fix for
 * assessment 1.5's silent caps: a lone `limit: 1000` doesn't error past
 * 1,000 rows, it just quietly truncates, and stats built from it (map
 * collected-coloring, geography counts, Set checkmarks) go wrong without
 * announcing it.
 *
 * Callers here build Sets/aggregates, so row ORDER doesn't matter — a
 * unique column (default the primary key `id`) just cursors the pages.
 * Offset pagination stays banned (V2-PLAN §9); this is keyset, same as
 * the feeds. maxBatches is a runaway backstop, generous on purpose:
 * requests only continue while pages come back full.
 */
import * as gateway from './gateway.js';

export async function drainRows(table, {
  select,
  filters = {},
  uniqueKey = 'id',
  batch = 1000,
  maxBatches = 20,
} = {}) {
  const all = [];
  let cursor = null;
  for (let i = 0; i < maxBatches; i++) {
    const pageFilters = { ...filters };
    if (cursor !== null) pageFilters[uniqueKey] = `gt.${cursor}`;
    const { data, error } = await gateway.rawQuery(table, {
      select, // must include uniqueKey — it's the cursor
      filters: pageFilters,
      order: `${uniqueKey}.asc`,
      limit: batch,
    });
    if (error) throw error;
    const rows = data || [];
    all.push(...rows);
    if (rows.length < batch) break;
    cursor = rows[rows.length - 1][uniqueKey];
  }
  return all;
}
